import * as React from "react";
import {
  Box,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import "./UserAccountPage.css";

const UserPage = () => {
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  if (!user?.results) {
    return (
      <div className="user-page-empty">
        <Typography className="user-page-empty-text">
          No user information available.
        </Typography>
      </div>
    );
  }

  const createdAt = user.results.createdAt;
  const joinedMoment = moment(createdAt);
  const joinedDate = joinedMoment.isValid()
    ? joinedMoment.format("DD MMM YYYY")
    : createdAt;
  const joinedRelative = joinedMoment.isValid() ? joinedMoment.fromNow() : "";

  return (
    <div className="user-page-root">
      <Container maxWidth="md" className="user-page-container">
        <Paper elevation={0} className="user-card">
          {/* Header section */}
          <Box className="user-card-header">
            <div className="user-card-header-left">
              <Typography className="user-card-title">My Profile</Typography>
              <Typography className="user-card-subtitle">
                The details the bank holds for your CBX Suite account.
              </Typography>
            </div>

            <div className="user-card-header-right">
              <span className="user-pill user-pill--role">
                {user.results.userRole || "User"}
              </span>
              <span className="user-pill user-pill--branch">
                {user.results.branch}
              </span>
            </div>
          </Box>

          {/* Info grid */}
          <Box className="user-info-grid">
            <div className="user-info-field">
              <Typography className="user-info-label">First Name</Typography>
              <TextField
                value={user.results.firstName}
                InputProps={{ readOnly: true }}
                type="text"
                size="small"
                variant="outlined"
                className="user-info-input"
                fullWidth
              />
            </div>

            <div className="user-info-field">
              <Typography className="user-info-label">Last Name</Typography>
              <TextField
                value={user.results.lastName}
                InputProps={{ readOnly: true }}
                type="text"
                size="small"
                variant="outlined"
                className="user-info-input"
                fullWidth
              />
            </div>

            <div className="user-info-field">
              <Typography className="user-info-label">Email</Typography>
              <TextField
                value={user.results.email}
                InputProps={{ readOnly: true }}
                type="text"
                size="small"
                variant="outlined"
                className="user-info-input"
                fullWidth
              />
            </div>

            <div className="user-info-field">
              <Typography className="user-info-label">Branch</Typography>
              <TextField
                value={user.results.branch}
                InputProps={{ readOnly: true }}
                type="text"
                size="small"
                variant="outlined"
                className="user-info-input"
                fullWidth
              />
            </div>

            <div className="user-info-field">
              <Typography className="user-info-label">Role</Typography>
              <TextField
                value={user.results.userRole}
                InputProps={{ readOnly: true }}
                type="text"
                size="small"
                variant="outlined"
                className="user-info-input"
                fullWidth
              />
            </div>

            <div className="user-info-field">
              <Typography className="user-info-label">Joined</Typography>
              <TextField
                value={
                  joinedRelative
                    ? `${joinedDate} • ${joinedRelative}`
                    : joinedDate
                }
                InputProps={{ readOnly: true }}
                type="text"
                size="small"
                variant="outlined"
                className="user-info-input"
                fullWidth
              />
            </div>
          </Box>

          <Box className="user-card-footer">
            <Typography className="user-card-note">
              Your name, branch and role are managed by your administrator.
              Contact them if any of these details are wrong.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default UserPage;
